import { useEffect } from "react";

declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}

export default function FbPixel() {
  useEffect(() => {
    // Facebook Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '640340862363932');fbq('track', 'PageView');`;
    document.head.appendChild(script);

    // Noscript fallback for users with JavaScript disabled
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=640340862363932&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);

    return () => {
      // Cleanup script
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
      // Cleanup noscript
      if (document.body.contains(noscript)) {
        document.body.removeChild(noscript);
      }
      delete window.fbq;
      delete window._fbq;
    };
  }, []);

  return null;
}

const FbPixelEvent_PageView = () => {
  console.log("Triggered: FB_pixel_Event-PageView");
  window.fbq && window.fbq("track", "PageView");
};

const FbPixelEvent_Lead = () => {
  console.log("Triggered: FB_pixel_Event-Lead");
  window.fbq && window.fbq("track", "Lead");
};

const FbPixelEvent_ViewContent = () => {
  console.log("Triggered: FB_pixel_Event-ViewContent");
  window.fbq && window.fbq("track", "ViewContent");
};

const FbPixelEvent_CompleteRegistration = () => {
  console.log("Triggered: FB_pixel_Event-CompleteRegistration");
  window.fbq && window.fbq("track", "CompleteRegistration");
};

const FbPixelEvent_AddPaymentInfo = () => {
  console.log("Triggered: FB_pixel_Event-AddPaymentInfo");
  window.fbq && window.fbq("track", "AddPaymentInfo");
};

const FbPixelEvent_StartTrial = (amount: number) => {
  console.log("Triggered: FB_pixel_Event-StartTrial", { value: amount, currency: 'INR' });
  window.fbq && window.fbq("track", "StartTrial", { value: amount, currency: 'INR' });
};

const FbPixelEvent_Subscribe = (amount: number) => {
  console.log("Triggered: FB_pixel_Event-Subscribe", { value: amount, currency: 'INR' });
  window.fbq && window.fbq("track", "Subscribe", { value: amount, currency: 'INR' });
};

export { 
  FbPixelEvent_Lead, 
  FbPixelEvent_PageView,
  FbPixelEvent_ViewContent,
  FbPixelEvent_CompleteRegistration,
  FbPixelEvent_AddPaymentInfo,
  FbPixelEvent_StartTrial,
  FbPixelEvent_Subscribe
};
